//@flow

import React from 'react';
import styled from 'styled-components';
import { withFlux } from '@homie/flux';
import DashboardStore from 'modules/dashboards/store/DashboardApplicationsStore';

const Navigator = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 85px);
  overflow: hidden;
`;
const Content = styled.div`
  width: 90%;
`;
const Item = styled.li`
  width: 100%;
  cursor: pointer;
  list-style-type: none;
  padding: 19px 20px 15px 11px;
  border-bottom: 1px solid #fff;
  color: #fff;
  background: ${props => (props.active ? '#1201AD' : '#9991c9')};
  &:hover {
    background: #1201ad;
  }
`;

const Nav = styled.div`
  display: flex;
  width: 10%;
  flex-direction: column;
  background: #9991c9;
`;

type PropsType = {
  children: any,
  history: any,
  options: [],
  currentStatus: string,
  onOptionClick: string => void,
  totals: any,
  showTotals: boolean
};

const Sidebar = ({
  currentStatus,
  options,
  children,
  onOptionClick,
  totals,
  showTotals
}: PropsType) => {
  const total = (filter: string) => (showTotals ? `(${totals[filter]})` : '');

  return (
    <Navigator>
      <Nav>
        {options.map(({ name, filter }, index) => (
          <Item
            key={index}
            active={currentStatus === filter}
            onClick={() => onOptionClick(filter)}
          >
            {`${name} ${total(filter)}`}
          </Item>
        ))}
      </Nav>
      <Content>{children}</Content>
    </Navigator>
  );
};

export default withFlux([DashboardStore], () => ({
  totals: DashboardStore.totals
}))(Sidebar);
